(function () {
    'use strict';

    angular.module("imApp").factory("consignmentLinesBsService", ['$ihttp', function ($ihttp) {
        let service = {
            listPicked: function (parms) {
                return $ihttp.post({
                    method: 703,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
